module.exports = __webpack_public_path__ + "static/media/orientation.017ad2ed.png";